import { Component, Mixins } from 'vue-property-decorator'
import { TheClientChoiceTableMixin } from '@core/components/basicRecommendation/TheClientChoiceTableMixin'
import TheClientChoiceTR from '@/views/kyc-form/component/TheClientChoiceTR.vue'

@Component({
  components: {
    TheClientChoiceTR
  }
})
export class CustomTheClientChoiceTableMixin extends Mixins(TheClientChoiceTableMixin) {
}
